import Axios from "@app/api/axios";

import { GENERATE_SHARE_REPORT_LINK } from "@utils/constant";

const createShareLinkService = reportId =>
  Axios.get(`${GENERATE_SHARE_REPORT_LINK}/${reportId}`);

export default createShareLinkService;
